export function getEndpointUrl(path: string) {
    return `*${path}`;
}
